import React, {useState, useEffect, useContext, useRef, useCallback} from 'react';
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import axios from 'axios'
import {
  AUTHORIZED_URL_PREFIX,
  CREATE_URL,
  AxiosConfig,
  NOTIFICATION_SEVERITY_INFO,
  NOTIFICATION_SEVERITY_SUCCESS,
  NOTIFICATIONS_URL,
  DELETE_NOTIFICATION_BY_ID,
  NOTIFICATION_STORY_UPLOAD,
  GET_ACTIVE_TENANT_USERS
} from '../../Utils/Constants'
import './create.css'
import t from "../../Utils/Translation";
import LykioButton from "../common/LykioButton";
import Form from 'react-bootstrap/Form';
import { notify, pleaseRefreshError } from '../../Utils/Notificator'
import Loading from '../common/Loading'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { createReactEditorJS } from 'react-editor-js'
import { EDITOR_JS_TOOLS } from './EditorJSTools'
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Ratio from 'react-bootstrap/Ratio';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import RefreshIcon from '@mui/icons-material/Refresh';
import {styled} from "@mui/material/styles";
import {Box, Fade, FormControlLabel, FormGroup, Switch} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {Modal} from "react-bootstrap";

import {base64StringToFile} from "../../Utils/ImageCropUtils";


import { CropperRef, Cropper } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css'
import PreviewStory from './PreviewStory';

import createDOMPurify from 'dompurify';
import CoverImageInput from "./CoverImageInput";



const ReactEditorJS = createReactEditorJS()
const editorjsHTML = require('editorjs-html')

const LykioPostStoryButton = styled(Button)(() => ({
  backgroundColor: "#003d7d",
  color: "white",
  borderColor: "#c4c5c7",
  '&:hover': {
    backgroundColor: "white",
    color: "#003d7d",
    borderStyle: 'solid !important',
    borderWidth: '0.2em',
    borderRadius: '7px',
    borderColor: "#003d7d"
  },
}));

const useStyles = makeStyles({
  colorOption: {
    width: '25%',
    height: '40px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '40px'
  },

});


const colorOptions = ["#f8ae35", "#00a58c", "#964bb6", "#0076bd", "#006f4b", "#8b0000"]
const defaultColor = colorOptions[3];

const Create = () => {
  const context = useContext(LykioContext);
  const tenantProperties = context.tenantProperties;

  const [title, setTitle] = useState('');
  const [duration, setDuration] = useState(1);

  const [isPdf, setIsPdf] = useState(false);

  const [selectedColor, setSelectedColor] = useState(defaultColor);
  const classes = useStyles();


  const [showCropModal, setShowCropModal] = useState(false)

  const handleColorChange = (color) => {
    if (selectedColor === color) {
      setSelectedColor(color);
    } else {
      setSelectedColor(color);
    }
  };

  const handleDurationChange = (event) => {
    const newValue = event.target.value;
    console.log(newValue);
    if (newValue === '' || (newValue && parseInt(newValue) > 1)) {
      setDuration(newValue);
    }else{
      setDuration(1);
    }
  }

  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [tenantUsers, setTenantUsers] = useState([]);
  const [uploaderId, setUploaderId] = useState(undefined);


  const [video, setVideo] = useState(null)
  const [pdf, setPdf] = useState(null);
  const [image, setImage] = useState(null)


  const fileInputRef = useRef();
  const [crop, setCrop] = useState({aspect: 1/1})
  const [imgSrc, setImgSrc] = useState(null)
  const cropperRef = useRef();

  const [coverImageFile, setCoverImageFile] = useState();



  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if(file.type.startsWith("image")){
        setImgSrc(URL.createObjectURL(file))
        setFile(event.target.files[0]);
        setShowCropModal(true)
        // event.target.value = "";
      }
      else{
        setFile(event.target.files[0]);
        setVideo(URL.createObjectURL(event.target.files[0]));
      }
    }
  }


  const handleSaveCrop = () => {
    const cropper = cropperRef.current;
    const canvas = cropper.getCanvas()
    setImage(canvas.toDataURL())
    const newFile = base64StringToFile(canvas.toDataURL(), file.name)
    setFile(newFile)
    setShowCropModal(false)
  }




  const onPdfChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setPdf(URL.createObjectURL(event.target.files[0]))
    }
  }

  useEffect(() => {
    const getUsers = async()=>{
      const { data } = await axios.get(
          `${AUTHORIZED_URL_PREFIX}${GET_ACTIVE_TENANT_USERS}`,
          AxiosConfig(),
      )
      if(data.success){
        setTenantUsers(data.tenantUsers);
      }
    }
    getUsers();
  },[])

  useEffect(() => {
    const interval = setInterval(() => {
      const fetchNotifications = async () => {
        try {
          const { data } = await axios.get(
              `${AUTHORIZED_URL_PREFIX}${NOTIFICATIONS_URL}`,
              AxiosConfig(),
          )
          let uploadsNotifications = data.notifications.filter(
              (notification) => notification.type === NOTIFICATION_STORY_UPLOAD,
          )
          if (uploadsNotifications.length > 0) {
            setIsLoading(false)
            notify({
              title: `${t('Your story was uploaded and is now under review')}`,
              severity: NOTIFICATION_SEVERITY_SUCCESS,
              creationDate: '',
            })
            await axios.post(
                `${AUTHORIZED_URL_PREFIX}${DELETE_NOTIFICATION_BY_ID}`,
                { notificationId: uploadsNotifications[0]._id },
                AxiosConfig(),
            )
          }
        } catch (error) {
          console.log(error);
        }
      }

      fetchNotifications()
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  const initEditorJSData = null
  const [editorJSDataHTML, setEditorJSDataHTML] = useState('')

  // EDITOR JS INIT & SETUP
  const editorJSInstance = React.useRef(null)

  // Initialize the HTML parser
  const edjsParser = editorjsHTML()

  const handleEditorJsInitialize = React.useCallback((instance) => {
    editorJSInstance.current = instance
  }, [])

  const handleEditorJsSave = React.useCallback(async () => {
    const savedEditorJSData = await editorJSInstance.current.save()
    setEditorJSDataHTML(edjsParser.parse(savedEditorJSData))
  }, [])

  const onEditorJSChange = () => {
    handleEditorJsSave()
  }

  const storyUploadHandler = async () => {
    if(title && file){
      // Editor JS DATA
      const editorJSDataHTMLString =
          editorJSDataHTML && editorJSDataHTML.map((htmlTags) => htmlTags).join(' ')

      try {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('userText',  editorJSDataHTMLString);
        formData.append('file', file);
        formData.append('duration', duration);
        formData.append('filetype', file.type);
        formData.append('uploaderId', uploaderId);
        formData.append('coverColor', selectedColor);
        formData.append('cover',coverImageFile)
        setIsLoading(true)
        const { data } = await axios.post(
            `${AUTHORIZED_URL_PREFIX}${CREATE_URL}`,
            formData,
            AxiosConfig('multipart/form-data'),
        )
        if (data.success) {
          setTitle('');
          setDuration(0);
          setFile(null);
          setImage(null);
          setVideo(null);
          setPdf(null);
          notify({
            title: `${t('Your story is being uploaded. Please stay on the page until the process is completed')}`,
            severity: NOTIFICATION_SEVERITY_INFO,
            creationDate: '',
          })
        } else {
          notify(pleaseRefreshError)
          console.log(data)
        }
      } catch (error) {
        console.log(error)
        notify(pleaseRefreshError)
      }
    }
    else{
      notify({
        title: `${t('Please fill out at least the title and a media file')}`,
        severity: NOTIFICATION_SEVERITY_INFO,
        creationDate: '',
      })
    }
  }


  return <div className="lykioccs-main-content" style={{paddingBottom:'0vh'}} >
    {isLoading ? (
        <Loading />
    ) : (
        <div className="lykioccs-main-content lykiocss-bacheca" style={{display: 'flex', justifyContent: 'center' ,alignItems: 'center'}}>
          <div className="lykiocss-center lykiocss-create-story-container" style={{width: '75%'}}>
            <Form className="lykiocss-form lykiocss-form-border lykiocss-form-size">
              <div className="lykiocss-center lykiocss-title-light">{t("Your Story")}</div>
              <div className='float-end'>
                <Tooltip title={t("Clear the form and start over")}>
                  <Button variant="text" onClick={()=> window.location.reload()}><RefreshIcon/></Button>
                </Tooltip>
              </div>
              <Container className="lykiocss-margin-top-1em" style={{width: '100%'}}>
                <Row>
                  <Col>
                  <Form.Group className="mb-3" controlId="title">
                    <FloatingLabel controlId="floatingtitle" label={t("Title")}>
                      <Form.Control
                          required
                          type="text"
                          maxLength={50}
                          placeholder={t("Enter title")}
                          value={title}
                          onChange={(e) => {
                            setTitle(e.target.value);
                          }}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <FormGroup>
                    <FormControlLabel control={<Switch  />} label={t("Upload PDF")} onChange={() => 
                      {setIsPdf(!isPdf)
                      setPdf(null)
                      setFile(null)
                      setImage(null)
                      setImgSrc(null)}} />
                  </FormGroup>
                  {!isPdf &&
                      <Form.Group className="mb-3" controlId="story">
                        <Form.Label>{t("Type your story here")}&nbsp;
                        </Form.Label>
                        <ReactEditorJS
                            style={{ border: "1px solid", paddingbottom: "300px" }}
                            onInitialize={handleEditorJsInitialize}
                            onChange={onEditorJSChange}
                            defaultValue={initEditorJSData}
                            /*data={initEditorJSData}*/
                            tools={EDITOR_JS_TOOLS}
                            minHeight={0}
                            inlineToolbar={true}
                        />
                      </Form.Group>
                  }
                  <p>{t('Select Post Color')}</p>
                  <Box display="flex" >
                    {colorOptions.map(color => (
                        <Box
                            key={color}
                            className={classes.colorOption}
                            style={{ backgroundColor: color }}
                            onClick={() => handleColorChange(color)}
                        >
                          {selectedColor === color ? <span style={{color: 'white'}}>{'\u2714'}</span> : ''}
                        </Box>
                    ))}

                  </Box>

                  <Form.Group className="mb-3 lykiocss-margin-top-1em" controlId="group">
                    <Form.Label>{t("Duration")}</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        value={duration}
                        placeholder={t("Enter Duration")}
                        onChange={handleDurationChange}
                    />
                  </Form.Group>
                  </Col>

                  <Col>
                  {tenantProperties && tenantProperties.enableUploadForOtherUsers && (
                      <Form.Group className="mb-3" controlId="title">
                        <Autocomplete
                            disablePortal
                            id="combo-box-users"
                            options={tenantUsers}
                            onChange={(event, value) =>
                                setUploaderId(value ? value.id : undefined)
                            }
                            renderInput={(params) => (
                                <TextField {...params} label={t("Uploading on behalf of")} />
                            )}
                        />
                      </Form.Group>
                  )}

                  {!isPdf ? <>
                        <Form.Group controlId="formFile" className="mb-3">
                          <Form.Label>{t('Your file')} &nbsp;
                            <Tooltip title={t('You can upload all popular image files. Video files .mp4 and .m4v are also accepted')}>
                              <i className="bi bi-info-square"></i>
                            </Tooltip>
                          </Form.Label>
                          <Form.Control
                              ref={fileInputRef}
                              filename={file}
                              accept="image/*,video/mp4,video/x-m4v"
                              required
                              type="file"
                              onChange={(e) => {
                                onImageChange(e);
                              }}
                          />
                        </Form.Group>




                      </>
                      : <>
                        <Form.Group controlId="formFile" className="mb-3">
                          <Form.Label>{t('Your file')} &nbsp;
                            <Tooltip title={t('You can upload only pdf files')}>
                              <i className="bi bi-info-square"></i>
                            </Tooltip>
                          </Form.Label>
                          <Form.Control
                              filename={file}
                              accept="application/pdf"
                              required
                              type="file"
                              onChange={(e) => {
                                setFile(e.target.files[0]);
                                onPdfChange(e);
                              }}
                          />
                        </Form.Group>
                        {pdf && <div >
                          <a href={pdf} target="_blank" rel="noopener noreferrer">
                            {t("View PDF")}
                          </a>
                        </div>}

                        <CoverImageInput setCoverImageFile={setCoverImageFile} coverImageFile={coverImageFile}/>



                      </>



                  }

                  <Form.Group controlId="formFileShow" className="mb-3">
                    {!image && !video && !pdf ?
                        <div className="lykiocss-create-file-showcase-message lykiocss-text-showcase-light">{t("Your file will show up here")}</div>
                        : <React.Fragment>
                          {image && <div className="lykiocss-create-file-showcase">
                            <Image fluid src={image} alt="preview image"/>
                          </div> }
                          {video && <div className="lykiocss-create-file-showcase">
                            <Ratio aspectRatio="1x1">
                              <div className="lykiocss-story-image">
                                <video width="100%" height="100%">
                                  <source
                                      src={`${video}#t=1`}
                                      type={file.mediatype}
                                  ></source>
                                </video>
                              </div>
                            </Ratio>
                          </div> }

                        </React.Fragment>

                    }

                  </Form.Group>
                    <Modal

                        show={showCropModal}
                        onHide={() => setShowCropModal(false)}
                        backdrop="static"
                        keyboard={false}
                    >

                      <Modal.Body>
                        <Cropper
                            src={imgSrc}
                            ref={cropperRef}
                            stencilProps={{
                              aspectRatio: 1/1
                            }}
                            // onChange={handleOnCropChange}
                        />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => handleSaveCrop()}>
                          {t("Crop")}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </Col>
                  <PreviewStory title={title} file={file} isPdf={isPdf} pdf={pdf} 
                  editorJSDataHTML={editorJSDataHTML} selectedColor={selectedColor} 
                  image={image} duration={duration}/>
                  
                </Row>
                <LykioPostStoryButton
                    onClick={()=> storyUploadHandler()}
                    variant="contained"
                    type="submit"
                    className={"float-end lykiocss-form-button "}

                >
                  {t("Create Post")}
                </LykioPostStoryButton>
              </Container>
            </Form>
          </div>
        </div>
       

    )}

  </div>
}









export default Create;
